<template>
  <div class="distribution-check">
    <el-tabs
      class="modify-el__tabs"
      v-model="activeName"
      @tab-click="handleClick"
    >
      <el-tab-pane label="已审核" name="2" lazy>
        <SearchComponent
          ref="search"
          :condition="condition"
          @updateData="_updateData"
          :routeName="$route.name"
          :activeName="activeName"
        >
          <template #default="{condition,filterDownData,pickerOptions}">
            <div class="input-box">
              <span class="name">分销商名称：</span>
              <div class="input">
                <el-input
                  placeholder="请输入"
                  v-model="condition.name"
                  clearable
                />
              </div>
            </div>
            <div class="input-box datepick">
              <span class="name">查询时间：</span>
              <div class="input">
                <el-date-picker
                  v-model="condition.time"
                  type="daterange"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  clearable
                  :picker-options="pickerOptions"
                />
              </div>
            </div>
            <div class="input-box">
              <span class="name">归属商家：</span>
              <div class="input">
                <el-select
                  placeholder="请选择"
                  v-model="condition.attributionMerchant"
                  clearable
                >
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    :key="item.value"
                    v-for="item in filterDownData('merchantList')"
                  />
                </el-select>
              </div>
            </div>
            <div class="input-box">
              <span class="name">分销商等级：</span>
              <div class="input">
                <el-select
                  v-model="condition.level"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="item in filterDownData('distributorList')"
                    :key="item.value"
                  />
                </el-select>
              </div>
            </div>
            <div class="input-box">
              <span class="name">审核方式：</span>
              <div class="input">
                <el-select
                  v-model="condition.checkType"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    :key="item.value"
                    v-for="item in filterDownData('auditMode')"
                  />
                </el-select>
              </div>
            </div>
          </template>
        </SearchComponent>
        <tableComponent
          ref="table"
          :tableData="tableData"
          :pagination="pagination"
          @updateData="_updateData"
          :routeName="$route.name"
        >
          <template #table="{tableData,tips}">
            <el-table-column
              fixed
              type="selection"
              align="center"
              width="130"
            />
            <el-table-column align="center" min-width="180">
              <template slot-scope="scope">
                <el-image
                  :src="scope.row.avatar"
                  class="avatar"
                  style="display: inline-block"
                >
                  <div slot="error" class="image-slot">
                    <i class="iconfont icon-tupian"></i>
                  </div>
                </el-image>
                <p class="ellipses">
                  {{ scope.row.vipName }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              prop="id"
              label="序号"
              align="center"
              min-width="60"
            />
            <el-table-column
              prop="cnName"
              show-overflow-tooltip
              align="center"
              label="姓名"
              min-width="180"
            />
            <el-table-column
              prop="time"
              label="申请时间"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="level"
              label="分销等级"
              align="center"
              min-width="180"
            />
            <el-table-column
              show-overflow-tooltip
              prop="attributionMerchant"
              label="归属商家"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="personalSalesMoney"
              label="个人销售金额"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="teamMonthSalesMoney"
              label="团队月度销售金额"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="twoDistributionNum"
              label="二级分销商数量"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="threeDistributionNum"
              label="三级分销商数量"
              align="center"
              min-width="180"
            />
            <el-table-column label="审核方式" align="center" min-width="180">
              <template slot-scope="scope">
                {{ scope.row.checkType | formatCheckType }}
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              align="center"
              min-width="180"
              class-name="visible flex"
            >
              <template slot-scope="scope">
                <el-button
                  size="36"
                  class="iconfont icon-chakanxiangqing d5"
                  v-permission:details="$route.meta.permission"
                  @click="handleEdit(scope.row)"
                  round
                />
                <el-button
                  size="36"
                  v-permission:disable="$route.meta.permission"
                  :class="
                    scope.row.status === '2'
                      ? 'iconfont icon-jinyong f3'
                      : 'iconfont icon-jinyong sub-color'
                  "
                  round
                  @click="userDisabled(scope.row)"
                />
              </template>
            </el-table-column>
          </template>
        </tableComponent>
      </el-tab-pane>
      <el-tab-pane label="待审核" name="1" lazy>
        <SearchComponent
          ref="search"
          :condition="condition"
          @updateData="_updateData"
          :routeName="$route.name"
          :activeName="activeName"
        >
          <template #default="{condition,filterDownData,pickerOptions}">
            <div class="input-box">
              <span class="name">分销商名称：</span>
              <div class="input">
                <el-input
                  placeholder="请输入"
                  v-model="condition.name"
                  clearable
                />
              </div>
            </div>
            <div class="input-box datepick">
              <span class="name">申请时间：</span>
              <div class="input">
                <el-date-picker
                  v-model="condition.time"
                  type="daterange"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  clearable
                  :picker-options="pickerOptions"
                />
              </div>
            </div>
            <div class="input-box">
              <span class="name">归属商家：</span>
              <div class="input">
                <el-select
                  placeholder="请选择"
                  v-model="condition.attributionMerchant"
                  clearable
                >
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    :key="item.value"
                    v-for="item in filterDownData('merchantList')"
                  />
                </el-select>
              </div>
            </div>
            <div class="input-box">
              <span class="name">分销商等级：</span>
              <div class="input">
                <el-select
                  v-model="condition.level"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="item in filterDownData('distributorList')"
                    :key="item.value"
                  />
                </el-select>
              </div>
            </div>
          </template>
        </SearchComponent>
        <tableComponent
          ref="table"
          :tableData="tableData"
          :pagination="pagination"
          @updateData="_updateData"
          :routeName="$route.name"
        >
          <template #table="{tableData,tips,checkStatus}">
            <el-table-column
              fixed
              type="selection"
              align="center"
              width="130"
            />
            <el-table-column fixed align="center" min-width="180">
              <template slot-scope="scope">
                <el-image
                  :src="scope.row.avatar"
                  class="avatar"
                  style="display: inline-block"
                >
                  <div slot="error" class="image-slot">
                    <i class="iconfont icon-tupian"></i>
                  </div>
                </el-image>
                <p class="ellipses">
                  {{ scope.row.vipName }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              fixed
              prop="id"
              label="序号"
              align="center"
              min-width="60"
            />
            <el-table-column
              prop="cnName"
              align="center"
              label="姓名"
              min-width="180"
            />
            <el-table-column
              prop="time"
              label="申请时间"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="level"
              label="分销等级"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="attributionMerchant"
              label="归属商家"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="personalSalesMoney"
              label="个人销售金额"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="teamMonthSalesMoney"
              label="团队月度销售金额"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="twoDistributionNum"
              label="二级分销商数量"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="threeDistributionNum"
              label="三级分销商数量"
              align="center"
              min-width="180"
            />

            <el-table-column
              fixed="right"
              label="操作"
              align="center"
              min-width="180"
              class-name="visible flex"
            >
              <template slot-scope="scope">
                <el-button
                  size="36"
                  @click="handleEdit(scope.row)"
                  v-permission:details="$route.meta.permission"
                  class="iconfont icon-chakanxiangqing d5"
                  round
                />
                <el-button
                  size="90"
                  class="sub-color"
                  v-permission:check="$route.meta.permission"
                  @click="checkStatus(scope.row)"
                  >审核
                </el-button>
              </template>
            </el-table-column>
          </template>
        </tableComponent>
      </el-tab-pane>
      <el-tab-pane label="审核不通过" name="3" lazy>
        <SearchComponent
          ref="search"
          :condition="condition"
          @updateData="_updateData"
          :routeName="$route.name"
          :activeName="activeName"
        >
          <template #default="{condition,filterDownData,pickerOptions}">
            <div class="input-box">
              <span class="name">分销商名称：</span>
              <div class="input">
                <el-input
                  placeholder="请输入"
                  v-model="condition.name"
                  clearable
                />
              </div>
            </div>
            <div class="input-box datepick">
              <span class="name">申请时间：</span>
              <div class="input">
                <el-date-picker
                  v-model="condition.time"
                  type="daterange"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  clearable
                  :picker-options="pickerOptions"
                />
              </div>
            </div>
            <div class="input-box">
              <span class="name">归属商家：</span>
              <div class="input">
                <el-select
                  placeholder="请选择"
                  v-model="condition.attributionMerchant"
                  clearable
                >
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    :key="item.value"
                    v-for="item in filterDownData('merchantList')"
                  />
                </el-select>
              </div>
            </div>
            <div class="input-box">
              <span class="name">分销商等级：</span>
              <div class="input">
                <el-select
                  v-model="condition.level"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="item in filterDownData('distributorList')"
                    :key="item.value"
                  />
                </el-select>
              </div>
            </div>
            <div class="input-box">
              <span class="name">审核方式：</span>
              <div class="input">
                <el-select
                  v-model="condition.checkType"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    :key="item.value"
                    v-for="item in filterDownData('auditMode')"
                  />
                </el-select>
              </div>
            </div>
          </template>
        </SearchComponent>
        <tableComponent
          ref="table"
          :tableData="tableData"
          :pagination="pagination"
          @updateData="_updateData"
          :routeName="$route.name"
        >
          <template #table="{tableData,tips}">
            <el-table-column
              fixed
              type="selection"
              align="center"
              width="130"
            />
            <el-table-column fixed align="center" width="120">
              <template slot-scope="scope">
                <el-image
                  :src="scope.row.avatar"
                  class="avatar"
                  style="display: inline-block"
                >
                  <div slot="error" class="image-slot">
                    <i class="iconfont icon-tupian"></i>
                  </div>
                </el-image>
                <p class="ellipses">
                  {{ scope.row.vipName }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              fixed
              prop="id"
              label="序号"
              align="center"
              min-width="60"
            />
            <el-table-column
              prop="cnName"
              align="center"
              label="姓名"
              min-width="180"
            />
            <el-table-column
              prop="time"
              label="申请时间"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="level"
              label="分销等级"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="attributionMerchant"
              label="归属商家"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="personalSalesMoney"
              label="个人销售金额"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="teamMonthSalesMoney"
              label="团队月度销售金额"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="twoDistributionNum"
              label="二级分销商数量"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="threeDistributionNum"
              label="三级分销商数量"
              align="center"
              min-width="180"
            />
            <el-table-column label="审核方式" align="center" min-width="180">
              <template slot-scope="scope">
                {{ scope.row.checkType | formatCheckType }}
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              align="center"
              width="180"
              class-name="visible flex"
            >
              <template slot-scope="scope">
                <el-button
                  size="36"
                  @click="handleEdit(scope.row)"
                  v-permission:details="$route.meta.permission"
                  class="iconfont icon-chakanxiangqing d5"
                  round
                />
                <el-button
                  size="36"
                  class="iconfont icon-shenhe f3"
                  @click="tips(scope.row.reason)"
                  round
                />
              </template>
            </el-table-column>
          </template>
        </tableComponent>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import SearchComponent from '../Components/SearchComponent/'
import TableComponent from '../Components/TableComponent/'
import updateData from 'mixins/updateData'
import tabsIndex from 'mixins/tabsIndex'

export default {
  name: 'check',
  mixins: [updateData, tabsIndex],
  components: {
    SearchComponent,
    TableComponent
  },
  data() {
    this.keyMap = {
      distributor_list: {
        name: 'tableData',
        add_time: 'time',
        audit_type: 'checkType',
        distributor_id: 'id',
        level_name: 'level',
        member_name: 'vipName',
        member_avatar: 'avatar',
        member_id: 'userId',
        merchant_name: 'attributionMerchant',
        order_amount: 'personalSalesMoney',
        personal_sales_amount: 'personalMonthSalesMoney',
        secondary_distributor_number: 'twoDistributionNum',
        team_sales_amount: 'teamMonthSalesMoney',
        tertiary_distributor_number: 'threeDistributionNum',
        true_name: 'cnName',
        distributor_status: 'status',
        rejection_reason: 'reason'
      }
    }
    return {
      activeName: '2',
      condition: {},
      tableData: [],
      pagination: {}
    }
  },
  created() {
    this._getDistributorList({
      curpage: 1,
      audit_status: this.activeName
    })
  },
  methods: {
    /**
     * 获取分销商列表
     * @param params
     * @private
     */
    _getDistributorList(params) {
      this.api.getDistributorList(params).then(res => {
        this.utils.setCommonCode(res, this)
      })
    },
    /**
     * 标签页切换
     * @param tab
     * @param event
     */
    handleClick(tab, event) {
      this.condition = {}
      this.pagination.currentPage = 1
      this._getDistributorList({
        curpage: 1,
        audit_status: this.activeName
      })
      this._tabsRecord()
    },
    /**
     * 编辑
     * @param row
     */
    handleEdit(row) {
      const { cnName, id } = row
      let status
      switch (this.activeName) {
        case '2':
          status = '已通过'
          break
        case '1':
          status = '未审核'
          break
        case '3':
          status = '审核不通过'
          break
      }
      this.$router.push({
        name: 'personalDetails',
        query: {
          title: `分销商审核 / ${status} / ${cnName}`,
          id: id
        }
      })
    },
    /**
     * 状态改变
     * @param row
     */
    userDisabled(row) {
      const { id, status } = row
      const newStatus = status === '1' ? '2' : '1'
      this.api
        .changeDistributorState({
          distributor_id: id,
          distributor_status: newStatus
        })
        .then(() => {
          row.status = newStatus
          this.$notify({
            type: 'success',
            message: '改变成功~！😁'
          })
        })
    }
  }
}
</script>
